
import store from '../../config/store'

export default {

  data: () => ({
    user: store.data.user,
    company: store.data.user.company,
  }),
  
  computed: {
    isCompany () {
      return this.company
    },
    addressInfo () {
      return this.isCompany ? this.company.address : this.user.address
    },
    getAvatarStyle () {
      if (store.data.user.picture_base64) {
        return `background-image: url(${store.data.user.picture_base64})`
      }
      return ''
    }
  },

  methods: {
    onCloseModal () {
      store.modal.active = false
    }
  }
}
